function SectionAnimate() {
    const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    let anims = [];
    let inc = -1;
    let wh = window.innerHeight;

    this.onscroll = scrollY => {
        for (const anim of anims) anim.onscroll(scrollY);
    };

    const onresize = () => {
        wh = window.innerHeight;
    }

    function section(el, type = 'top-bottom', animation) {
        const stickel = el.querySelector('.sticky');
        let isInside = false;
        let percent = 0;
        let value;
        let calc;
        let offset;

        new IntersectionObserver(entries => {
            entries.forEach(entry => {
                isInside = entry.isIntersecting;
                isInside ? el.classList.add('viewed') : el.classList.remove('viewed')
            });
        }).observe(el);

        if (type == 'top-bottom') calc = val => (-val + el.offsetTop) / (wh - el.clientHeight);

        if (type == 'bottom-bottom') calc = val => (val - el.offsetTop + wh) / el.clientHeight;

        if (type == 'top-top') calc = val => (val - el.offsetTop) / (el.clientHeight);

        if (type == 'bottom-top') calc = val => (val - el.offsetTop + wh) / (el.clientHeight + wh);

        this.onscroll = scrollY => {
            if (!isInside) return;
            percent = Math.round(calc(scrollY) * 10000) / 100;
            animation(this);
            if (stickel && !isTouch) {
                offset = scrollY - el.offsetTop;
                if (offset <= 0) offset = 0;
                if (percent >= 100) offset = el.offsetHeight - stickel.offsetHeight;
                stickel.style.transform = `translateY(${offset}px)`;
            }
        }

        this.steps = (els, p, func) => {
            for (let i = 0; i < els.length; i++) {
                this.timeline(p.gap * i + p.delay, p.gap * i + p.duration, val => func(els[i], val));
            }
        };

        this.timeline = (start, end, onscroll) => {
            value = (percent - start) / (end - start);
            if (percent < start) value = 0;
            if (percent > end) value = 1;
            onscroll(value * 100);
        }

        let once = true;
        let old = false;
        this.toggle = (trig, onscroll) => {
            once = percent > trig ? true : false;
            if (old !== once) {
                onscroll(!once);
                old = once;
            }
        }
    }

    this.add = (el, type, animation) => {
        anims.push(new section(el, type, animation));
        inc++;
        return anims[inc];
    }

    this.reset = () => {
        wh = window.innerHeight
        document.body.style.height = `${content.clientHeight}px`;
    }

    window.addEventListener('resize', onresize, { passive: true })
}

// 
function cssanim(el, name, duration = '.3s') {
    el.style.animation = `${name}-in ${duration} ease paused`;
    this.show = (delay = '0s') => el.style.animation = `${name}-in ${duration} ease ${delay} both`;
    this.hide = (delay = '0s') => el.style.animation = `${name}-out ${duration} ease ${delay} both`;
}

//
function jsanim(el, params) {
    const y = params.y || 0;
    const x = params.x || 0;
    const scale = params.scale || 1;
    const animation = [
        {
            opacity: 0,
            transform: `scale(${scale}) translate3d(${x},${y},0)`
        },
        {
            opacity: 1,
            transform: 'scale(1) translate3d(0,0,0)'
        }
    ]

    const options = {
        delay: params.delay || 0,
        duration: params.duration || 300,
        fill: 'both',
        easing: params.easing || 'ease'
    }

    el.animate(animation, options);
}

//
function strokeAnim(el, delay = 0) {
    const tLength = el.getTotalLength();
    el.style.strokeDasharray = tLength + ' ' + tLength;
    el.style.strokeDashoffset = tLength - (0 * tLength);
    el.style.visibility = "visible";

    el.animate(
        { strokeDashoffset: `${tLength - (1 * tLength)}px` }, {
        duration: 4000,
        delay: delay,
        fill: "both",
        easing: "ease"
        //easing: "cubic-bezier(0.120, 0.550, 0.895, 0.345)"
    });
}

//
function letterAppear(el) {
    const results = el.innerHTML.replaceAll('<br>', ' * ');
    const words = results.split(" ");
    el.innerHTML = words.map(w => w != '*' ? `<span>${Array.from(w).map(l => `<span>${l}</span>`).join('')}</span> ` : '<br>').join('');
    const spans = el.querySelectorAll('span span');
    spans.forEach((item, i) => {
        item.style = `--num: ${i}`;
        item.addEventListener('transitionstart', () => el.style.setProperty('--inc', i));
    });
}

//
function toggle() {
    let once = false;
    let statut = false;

    function trigger(percent, value, func) {
        statut = percent > value ? true : false;
        if (statut != once) {
            func(statut);
            once = statut;
        }
    }

    this.trig = (percent, value, func) => trigger(percent, value, func);
}

// heplers fo section animate
const translateX = (el, value) => el.style.transform = `translateX(${value})`;
const scale = (el, value) => el.style.transform = `scale(${value})`;
const clipToCenter = (el, val) => el.style.clipPath = `polygon(0 ${val / 2}%, 100% ${val / 2}%, 100% ${100 - val / 2}%, 0 ${100 - val / 2}%)`;
const clipFromBottom = (el, val) => el.style.clipPath = `polygon(0 0, 100% 0, 100% ${100 - val}%, 0 ${100 - val}%)`;
const unclipFromLeft = (el, val) => el.style.clipPath = `polygon(-4rem -4rem, calc(${val}% + ${val * 4 / 100}rem) -4rem, calc(${val}% + ${val * 4 / 100}rem) calc(100%  + 9rem), -4rem calc(100%  + 9rem))`
const widthTo = (el, val, start, end) => el.style.width = `${(start + (val * (end - start) / 100))}%`;
const heightTo = (el, val, start, end) => el.style.height = `${(start + (val * (end - start) / 100))}%`;
const translateY = (el, value) => el.style.transform = `translateY(${value})`;


export { SectionAnimate, translateY, translateX, scale, cssanim, strokeAnim, jsanim, letterAppear, toggle, clipToCenter, clipFromBottom, unclipFromLeft, widthTo, heightTo };